import React from 'react'

import { media } from '../styles/tools'

import Select from './Select'
import NextArrow from './NextArrow'
import FlagVideo from './FlagVideo'
import Space from './Space'
import Link from './Link'
import { BusinessTypeConsumer } from '../contexts/BusinessType'
import { DecideWhenToShowFooter, FooterContent, FooterData } from './Footer'
import { Headline, WideText, BoldText } from '../styles/typography'

const ChallengeUsFooter = () => (
  <DecideWhenToShowFooter>
    <FooterContent>
      <FlagVideo
        css={{ height: '100%', position: 'absolute', top: 0, left: 0 }}
      />
      <div
        css={{
          display: 'grid',
          gridTemplate: "'. details .' / 1fr 8fr 1fr",
          alignItems: 'center',
          width: '100%',
          position: 'relative',

          [media.tabletLg]: {
            gridTemplate: "'. form . details' / 1fr 3fr 2rem 2fr",
          },
        }}
      >
        <div
          css={{ gridArea: 'form', [media.max.tabletLg]: { display: 'none' } }}
        >
          <Headline as="h2">Challenge us.</Headline>
          <Space y={20} />
          <BoldText as="div">
            If you’re a{' '}
            <BusinessTypeConsumer>
              {({ selected, setSelected }) => (
                <Select
                  selected={selected}
                  onChange={({ value, selected }) => {
                    setSelected(selected)
                  }}
                  options={[
                    'foreign brand coming to the 🇺🇸',
                    'startup disrupting the market',
                    'company that needs to rebrand',
                  ]}
                  color="#999"
                  whiteSelected
                  border
                />
              )}
            </BusinessTypeConsumer>
            <br />
            then challenge us with your business problem or idea.
          </BoldText>
          <Space y={30} />
          <WideText as={Link} to="/contact#form">
            Start a project <NextArrow width="1.9em" />
          </WideText>
        </div>
        <FooterData css={{ gridArea: 'details' }} />
      </div>
    </FooterContent>
  </DecideWhenToShowFooter>
)

export default ChallengeUsFooter
